










































































import teipTableMixin from '@/mixins/teipTableMixinVueExtends';
import Vue from 'vue';

export default Vue.extend({
  name: 'TeipContactsTable',
  mixins: [teipTableMixin],
  methods: {
    documents(contact_id: string): void {
      this.$router.push({
        name: 'contacts-documents',
        params: {
          contact_id,
        },
      });
    },
    validateRoute(): boolean {
      if (this.$route.name === 'users-branch-contacts') {
        return false;
      }
      return true;
    },
  },
});
